
/**
 * 
 * @param {String} email 
 * @returns Retorna vedadeero si el email tiene el formato correcto y false si no.
 */
export const emailValidator = (email) => {
    const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    return emailRegex.test(email)
}